import React from 'react';
import './LocationData.css';

export const LocationData = ({ location }) => {
  // Extract coordinates if they exist in the location string
  const extractCoordinates = (locationStr) => {
    const coordsMatch = locationStr && locationStr.match(/(-?\d+\.\d+),\s*(-?\d+\.\d+)/);
    if (coordsMatch) {
      return {
        latitude: parseFloat(coordsMatch[1]),
        longitude: parseFloat(coordsMatch[2])
      };
    }
    // Return default coordinates if none found
    return { latitude: 0, longitude: 0 };
  };

  // Try to get coordinates from location data
  const coords = location.latitude && location.longitude ? 
    { latitude: location.latitude, longitude: location.longitude } : 
    extractCoordinates(location.location);

  return (
    <div className="location-data">
      <div className="location-header">
        <h4>Location Data</h4>
        <div className="location-timestamp">{location.timestamp || ''}</div>
      </div>
      <div className="location-map-container">
        {/* This would ideally be an actual map component, but for now just display a placeholder */}
        <div className="location-map-placeholder">
          <div className="map-pin"></div>
          <div className="coordinates">
            {coords.latitude !== 0 || coords.longitude !== 0 ? 
              `${coords.latitude.toFixed(6)}, ${coords.longitude.toFixed(6)}` : 
              location.location || 'Location coordinates unavailable'}
          </div>
        </div>
      </div>
      <div className="location-details">
        <div className="location-detail">
          <span className="detail-label">Location:</span>
          <span className="detail-value">{location.location || 'Unknown location'}</span>
        </div>
        {location.device && (
          <div className="location-detail">
            <span className="detail-label">Device:</span>
            <span className="detail-value">{location.device}</span>
          </div>
        )}
        {location.accuracy && (
          <div className="location-detail">
            <span className="detail-label">Accuracy:</span>
            <span className="detail-value">±{location.accuracy} meters</span>
          </div>
        )}
        {location.duration && (
          <div className="location-detail">
            <span className="detail-label">Duration:</span>
            <span className="detail-value">{location.duration}</span>
          </div>
        )}
      </div>
    </div>
  );
}; 